import React from "react";
import { MetaMaskProvider } from "metamask-react";
import { HashRouter } from "react-router-dom";

import ContextNavComponent from "../../../components/ContextNavComponent/ContextNavComponent";
import CodiaxWrapperPage from "./CodiaxWrapperPage";

import s from "./CodiaxPage.module.scss";

export default function CodiaxIndex() {
	return (
		<HashRouter>
			<MetaMaskProvider>
				<ContextNavComponent>
					<div className={s.root}>
						<CodiaxWrapperPage />
					</div>
				</ContextNavComponent>
			</MetaMaskProvider>
		</HashRouter>
	);
}
